import { ALTERAR_DETALHAMENTO_CONFIGURACAO_BILHETE } from '../types'

export default function alterarExibicaoDetalhamentoConfiguracaoBilhete (configuracao) {
    return {
      type: ALTERAR_DETALHAMENTO_CONFIGURACAO_BILHETE,
      payload: configuracao
    }
  }
  